import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Maintenance from "@/views/Maintenance.vue";
import Error403 from "@/views/Error403.vue";
import Error404 from "@/views/Error404.vue";
import Error500 from "@/views/Error500.vue";

Vue.use(VueRouter);

const routes = [{
    path: "/", redirect: "/home"
}, {
    path: "/home", name: "Home", meta: {
        shouldBeLoggedIn: true, menuKeyValue: "1", title: "Dashboard"
    }, component: Home
}, {
    path: "/users", name: "Users", meta: {
        shouldBeLoggedIn: true, menuKeyValue: "2", title: "Użytkownicy"
    }, component: () => import(/* webpackChunkName: "Account" */ "../views/Users.vue")
}, {
    path: "/users/:uuid", name: "User", meta: {
        shouldBeLoggedIn: true, menuKeyValue: "2", title: "Użytkownik"
    }, component: () => import(/* webpackChunkName: "Account" */ "../views/User.vue")
}, {
    path: "/calendar", name: "Calendar", meta: {
        shouldBeLoggedIn: true, menuKeyValue: "5", title: "Kalendarz"
    }, component: () => import(/* webpackChunkName: "Account" */ "../views/Calendar.vue")
}, {
    path: "/issues", name: "Issues", meta: {
        shouldBeLoggedIn: true, menuKeyValue: "6", title: "Zgłoszenia"
    }, component: () => import(/* webpackChunkName: "Account" */ "../views/Issues.vue")
}, {
    path: "/approvals", name: "Approvals", meta: {
        shouldBeLoggedIn: true, menuKeyValue: "9", title: "Potwierdzenia tożsamości"
    }, component: () => import(/* webpackChunkName: "Account" */ "../views/Events.vue")
}, {
    path: "/events", name: "Events", meta: {
        shouldBeLoggedIn: true, menuKeyValue: "10", title: "Zdarzenia"
    }, component: () => import(/* webpackChunkName: "Account" */ "../views/Events.vue")
}, //  {
    //    path: "/account",
    //    name: "Account",
    //    meta: {
    //      shouldBeLoggedIn: true,
    //      menuKeyValue: "99",
    //      title: "Panel użytkownika",
    //      subtitle: "Urządzenia",
    //    },
    //    component: () => import(/* webpackChunkName: "Account" */ "../views/Account.vue"),
    //  },
    {
        path: "/form",
        name: "Form",
        meta: {
            menuKeyValue: "99",
            shouldBeLoggedIn: true,
            title: "Formularz",
            subtitle: "Wniosek",
        },
        component: () => import(/* webpackChunkName: "Form" */ "../views/Form.vue"),
    },
    {
        path: "/nodes",
        name: "Nodes",
        meta: {
            menuKeyValue: "49",
            shouldBeLoggedIn: true,
            title: "Węzły",
        },
        component: () => import(/* webpackChunkName: "Form" */ "../views/Nodes.vue"),
    }, {
        path: "/tools", name: "Tools", meta: {
            shouldBeLoggedIn: true, menuKeyValue: "50", title: "Narzędzia"
        }, component: () => import(/* webpackChunkName: "Account" */ "../views/Tools.vue")
    },
    {
        path: "/account/login", name: "Login", meta: {
            menuKeyValue: "99", title: "Panel użytkownika", subtitle: "Logowanie"
        }, component: () => import(/* webpackChunkName: "Login" */ "../views/Login.vue")
    }, {
        path: "/account/logout", name: "Logout", meta: {
            menuKeyValue: "99", title: "Panel użytkownika", subtitle: "Wylogowanie"
        }, component: () => import(/* webpackChunkName: "Logout" */ "../views/Logout.vue")
    }, {
        path: "/maintenance", name: "Maintenance", meta: {
            menuKeyValue: "1", title: "Przerwa techniczna"
        }, component: Maintenance
    }, {
        path: "/error-403", name: "Error403", meta: {
            menuKeyValue: "1", title: "Błąd"
        }, component: Error403
    }, {
        path: "/error", name: "Error404", meta: {
            menuKeyValue: "1", title: "Błąd"
        }, component: Error404
    }, {
        path: "/error-500", name: "Error500", meta: {
            menuKeyValue: "1", title: "Błąd"
        }, component: Error500
    }, {
        path: "*", meta: {
            menuKeyValue: "1", title: "Błąd"
        }, redirect: "/error"
    }];

const router = new VueRouter({
    mode: "history", base: process.env.BASE_URL, routes
});

router.beforeEach((to, from, next) => {
    let isLoggedIn = localStorage.getItem("isLoggedIn") != null ? localStorage.getItem("isLoggedIn") : false
    let shouldBeLoggedIn = to.meta.shouldBeLoggedIn != null ? to.meta.shouldBeLoggedIn : false

    if (!isLoggedIn && shouldBeLoggedIn) {
        next({name: "Login"})
    } else {
        next()
    }
})

export default router;
